import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Size, Shadow } from '../../constants';
import colors from '../../themes/main-colors';

const useStyles = makeStyles((theme: Theme) => {
  const { palette } = theme;

  // Colors
  const { white } = palette.common;
  const { main: primary, contrastText: text } = palette.primary;
  const emphasis = palette.warning.main;
  const back = palette.grey[800];
  const disabled = palette.grey[600];
  const darkText = palette.text.primary;

  return createStyles({
    root: {
      borderRadius: `${theme.spacing(5)}px`,
      boxSizing: 'border-box',

      '&.btn-Block': {
        lineHeight: '1.125rem',
      },

      '&:not(.btn-Text)': {
        padding: '13px 32px',
        fontSize: '18.66px',
      },

      '& svg': {
        width: 14,
        height: 14,
      },

      '.bkg-Dark &.btn-Text': {
        position: 'relative',

        '& span': {
          zIndex: 2,
        },

        '&::before': {
          boxSizing: 'content-box',
          content: '""',
          display: 'block',
          position: 'absolute',
          width: '100%',
          height: '100%',
          padding: '0 4px',
          background: 'transparent',
          zIndex: 1,
        },

        '&:hover, &:focus': {
          color: darkText,
          textDecoration: 'none',
        },
      },
    },

    // Material common variants
    contained: {
      boxShadow: 'none',

      '&:hover, &:focus': {
        boxShadow: Shadow.TWO,
      },
    },
    disabled: {
      background: disabled,
      opacity: 1,
      pointerEvents: 'none',
    },
    outlined: {
      borderWidth: 2,

      '&:hover, &:focus': {
        borderWidth: 2,
        boxShadow: Shadow.TWO,
      },
    },
    text: {
      padding: 0,
      textAlign: 'inherit',

      '&.btn-Block': {
        fontSize: '1rem',
      },

      '&.btn-Inline': {
        minWidth: 'unset',
        font: 'inherit',
        verticalAlign: 'unset',
        display: 'inline',
      },

      '& .MuiButton-label': {
        textDecoration: 'underline',
        fontWeight: 'bold',
      },
    },
    endIcon: {
      margin: '0 1px 1px 4px',
    },
    startIcon: {
      margin: '0 4px 1px 1px',
    },

    // Contentful field overrides
    primary: {
      '&:hover, &:focus': {
        color: colors.white,
        backgroundColor: colors.noirBlurLight,
      },
      '&:disabled': {
        color: colors.cloudGrey2,
        backgroundColor: colors.grey3,
      },
    },
    secondary: {
      borderColor: primary,

      '&:hover, &:focus': {
        color: colors.noirBlurLight,
        borderColor: colors.noirBlurLight,
        backgroundColor: colors.white,
      },
      '&:disabled': {
        color: colors.grey3,
        backgroundColor: colors.white,
        borderColor: colors.grey3,
      },
    },
    emphasis: {
      background: emphasis,
      color: text,
      fontWeight: 700,

      '&:hover, &:focus': {
        color: colors.navBarBackground,
        backgroundColor: colors.crail,
      },
      '&:disabled': {
        color: colors.cloudGrey2,
        backgroundColor: colors.grey3,
      },
    },
    back: {
      background: back,
      color: text,
    },
    outline: {
      color: colors.noirBlur,
      backgroundColor: colors.navBarBackground,
      borderColor: colors.noirBlur,

      '&:hover, &:focus': {
        border: `2px solid ${colors.noirBlur}`,
        backgroundColor: colors.linenWhite,
        color: colors.noirBlur,
      },
    },
    pill: {
      background: text,
      borderRadius: '60px',
      boxShadow: Shadow.ONE,

      '&:hover, &:focus': {
        background: text,
        boxShadow: Shadow.THREE,
      },
    },
  });
});

export default useStyles;
